import React from "react";

import { CupProps } from "./types";
import { useCup } from "./hooks";

export const Cup = (props: CupProps) => {
  const { getCupProps } = useCup(props);
  return <img {...getCupProps()} />;
};
